import { coreClient } from "../apollo";
import gql from "graphql-tag";

export const UserState = {
  namespaced: true,
  state: {
    user: {
      id: "",
      name: "",
      email: "",
      avatar: "",
      phone: "",
      company: {},
      roles: [],
      actions: [],
      resources: []
    }
  },
  mutations: {
    set(state, user) {
      state.user = user;
    }
  },
  actions: {
    async getAccount({ commit }) {
      try {
        const { data } = await coreClient.query({
          query: gql`
            {
              me {
                id
                name
                email
                avatar
                phone
                company {
                  id
                  name
                  logo
                  address
                  phone
                }
              }
              myRoles {
                id
                name
                actions {
                  name
                  resource {
                    name
                  }
                }
              }
            }
          `,
          fetchPolicy: "no-cache"
        });

        const { myRoles } = data;
        let actions = []; // actions is a name to value pair.
        let resources = {};
        myRoles.forEach(role => {
          role.actions.forEach(action => {
            resources[action.resource.name] = [
              ...(resources[action.resource.name] || []),
              action.name
            ];
            actions.push(`${action.name}/${action.resource.name}`);
          });
        });

        commit("set", { ...data.me, roles: data.myRoles, actions, resources });
      } catch (e) {
        // Handle this later.
      }
    },
    async changePassword({}, variables) {
      try {
        const { data } = await coreClient.mutate({
          mutation: gql`
            mutation changeMyPassword($old: String!, $new: String!) {
              changeMyPassword(password: $old, newPassword: $new)
            }
          `,
          variables
        });

        if (data.changeMyPassword) {
          // success
        }

        // failed
      } catch (e) {
        // handle this later.
      }
    },
    async updateAccount({ commit }, obj) {
      try {
        const { data } = await coreClient.mutate({
          mutation: gql`
            mutation updateMyAccount(
              $name: String
              $email: String
              $phone: String
            ) {
              updateMyAccount(name: $name, email: $email, phone: $phone) {
                id
                name
                email
                avatar
                phone
                company {
                  id
                  name
                  logo
                  address
                  phone
                }
              }
            }
          `,
          variables: obj
        });

        commit("set", data.updateMyAccount);

        // succeeded
      } catch (e) {
        // failed, handle this later.
      }
    }
  },
  getters: {
    user: state => state.user
  }
};
